import { render } from "./MWImageSwiper.vue?vue&type=template&id=10e6a8c6&scoped=true"
import script from "./MWImageSwiper.vue?vue&type=script&lang=js"
export * from "./MWImageSwiper.vue?vue&type=script&lang=js"

import "./MWImageSwiper.vue?vue&type=style&index=0&id=10e6a8c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e6a8c6"]])

export default __exports__